// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ecc9243a","787":"91e42d70"}[chunkId] + ".chunk.js";
};